import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { showEpayTransaction } from '~/config/routes';
import List from './List';
import Show from './Show';
import { EpayTransactionProvider } from './context';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function EpayTransactions() {
  return (
    <EpayTransactionProvider>
      <Switch>
        <Route
          exact
          path={showEpayTransaction.spec}
          render={(props) => (
            <>
              <Can I="show" a="EpayTransactions">
                {() => <Show {...props} />}
              </Can>
              <Can not I="show" a="EpayTransactions">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          render={(props) => (
            <>
              <Can I="list" a="EpayTransactions">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="EpayTransactions">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </EpayTransactionProvider>
  );
}
export default EpayTransactions;
